// extracted by mini-css-extract-plugin
export var active = "_ef-2";
export var recordingDot = "_ef-1";
export var recordingIndicator = "_ef-0";